var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicantCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18389_62358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68518 12.0004C1.33944 11.8532 1.2301 11.5885 1.2366 11.2209C1.25315 10.2805 1.24192 9.33906 1.24192 8.39816V8.18066C3.01379 9.33787 4.77206 9.34024 6.5587 8.18125C6.5587 8.25336 6.5587 8.3166 6.5587 8.37925C6.5587 9.32605 6.54747 10.2735 6.56402 11.2203C6.57052 11.5873 6.46059 11.8521 6.11544 11.9998H5.81993C5.22951 11.6635 4.63731 11.3308 4.05043 10.9892C3.93991 10.9248 3.86012 10.9271 3.75019 10.9904C3.16272 11.332 2.57052 11.6641 1.9801 11.9998H1.68459L1.68518 12.0004Z",
    fill: "#26A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91017 5.38697e-06C6.05969 0.00355149 7.80733 1.76183 7.80083 3.91549C7.79433 6.05497 6.04256 7.80024 3.9013 7.80083C1.75059 7.80142 -0.00177171 6.0467 1.3443e-06 3.8954C0.00177439 1.7441 1.75591 -0.00354071 3.91017 5.38697e-06ZM3.34752 4.01892C3.16549 3.90071 3.00414 3.78428 2.83215 3.68618C2.50118 3.49764 2.10284 3.59516 1.89421 3.90544C1.68617 4.21514 1.74055 4.6318 2.04846 4.85402C2.42435 5.1253 2.81206 5.38358 3.20804 5.62471C3.51064 5.80911 3.89716 5.73523 4.09811 5.44268C4.60402 4.70863 5.10166 3.96809 5.57861 3.21454C5.81206 2.84575 5.61584 2.37353 5.20745 2.21573C4.90426 2.09871 4.58038 2.198 4.37589 2.4941C4.03192 2.99055 3.69977 3.49469 3.34752 4.01833V4.01892Z",
    fill: "#26A96C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18389_62358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.80083,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantCheck);
export default ForwardRef;